var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSavedAgentsInactive = function SvgSavedAgentsInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    d: "M9.5 21H19a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H9.5v5Zm0-6.5H19a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H9.5v5ZM8 9.5v5H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h3ZM9.5 8H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9.5v5ZM8 16v5H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "M3.87 1.657a.675.675 0 0 1 1.26 0l.342.895c.171.45.526.805.976.976l.895.341c.58.22.58 1.041 0 1.262l-.895.34c-.45.172-.805.527-.976.977l-.341.895a.675.675 0 0 1-1.262 0l-.34-.895a1.688 1.688 0 0 0-.977-.976l-.895-.341a.675.675 0 0 1 0-1.262l.895-.34c.45-.172.805-.527.976-.977l.341-.895Z"
  })));
};
export default SvgSavedAgentsInactive;